import React, { useState } from 'react';
import { Modal, Button, Row, Col, Table, Badge, Form } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { cleanCpfCnpj, validarCpfCnpj } from '~/Utils/Helpers';
import { customStyles as selectStyles } from '~/Styles/reactSelectStyles';

var STATUS_CORES = {
  B: '#000000',
  V: '#FF0000',
  R: '#FF8000',
  P: '#0000FF',
  A: '#00FF80',
  D: '#008000',
  O: '#FFFF00',
};

var STATUS_LABELS = {
  B: 'Bloqueado',
  V: 'Vendido',
  R: 'Reservado',
  P: 'Pré-Venda',
  A: 'Alugado',
  D: 'Disponível',
  O: 'Proposta Rápida',
};

var opcoesStatus = [
  { value: 'B', label: 'Bloqueado' },
  { value: 'R', label: 'Reservado' },
  { value: 'D', label: 'Disponível' },
];

var formatarMoeda = (valor) => {
  if (valor == null) return '-';
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

var formatarData = (data) => {
  if (!data) return '-';
  var d = new Date(data);
  return d.toLocaleDateString('pt-BR');
};

var formatarDataHora = (data) => {
  if (!data) return '-';
  var d = new Date(data);
  return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
};

var ModalDetalhe = ({
  show,
  onHide,
  detalhe,
  imovelMapa,
  codigoFamilia,
  onAlterarStatus,
  controlaPropostaVda,
  onRecarregar,
}) => {
  var novoStatusState = useState(null);
  var novoStatus = novoStatusState[0]; var setNovoStatus = novoStatusState[1];

  var cpfState = useState('');
  var cpf = cpfState[0]; var setCpf = cpfState[1];

  var exclusivoState = useState(false);
  var exclusivo = exclusivoState[0]; var setExclusivo = exclusivoState[1];

  var observacaoState = useState('');
  var observacao = observacaoState[0]; var setObservacao = observacaoState[1];

  var loadingState = useState(false);
  var loading = loadingState[0]; var setLoading = loadingState[1];

  var temPerm64 = AuthStorage.temCaracteristicas([caracteristicas.BloquearImovel]);
  var temPerm251 = AuthStorage.temCaracteristicas([caracteristicas.BloquearImovelUsuario]);

  var statusAtual = detalhe ? detalhe.status : null;
  var podeAlterar = statusAtual && (statusAtual === 'B' || statusAtual === 'R' || statusAtual === 'D');

  var opcoesFiltradas = opcoesStatus.filter((op) => {
    if (op.value === 'B' || op.value === 'D') return temPerm64;
    return true;
  });

  var handleConfirmar = () => {
    if (!novoStatus) {
      toast.error('Selecione o novo status.');
      return;
    }
    if ((novoStatus.value === 'B' || novoStatus.value === 'D') && !temPerm64) {
      toast.error('Usuário sem permissão para Bloquear/Disponibilizar Imóvel.');
      return;
    }
    if (cpf && cpf.trim() !== '') {
      if (!validarCpfCnpj(cpf)) {
        toast.error('CPF/CNPJ inválido.');
        return;
      }
    }

    setLoading(true);
    onAlterarStatus({
      codigo_ativo: detalhe.codigo_ativo,
      codigo_familia: codigoFamilia || 0,
      novo_status: novoStatus.value,
      cpf: cpf ? cleanCpfCnpj(cpf) : null,
      exclusivo: exclusivo,
      observacao: observacao,
    })
      .then(() => {
        toast.success('Status alterado com sucesso.');
        setNovoStatus(null);
        setCpf('');
        setExclusivo(false);
        setObservacao('');
        onHide();
        onRecarregar && onRecarregar();
      })
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao alterar status';
        toast.error(msg);
      })
      .finally(() => setLoading(false));
  };

  var statusCor = detalhe ? (STATUS_CORES[detalhe.status] || '#6c757d') : '#6c757d';
  var statusLabel = detalhe ? (STATUS_LABELS[detalhe.status] || detalhe.status) : '';

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#0747a6', color: 'white' }}
      >
        <Modal.Title style={{ fontSize: 16, color: '#ffffff' }}>
          Detalhe do Imóvel
          {detalhe ? ` — Quadra ${detalhe.mapa1} Lote ${detalhe.mapa2}` : ''}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!detalhe ? (
          <div className="text-center">Carregando...</div>
        ) : (
          <>
            <Row className="mb-2">
              <Col xs={12} className="mb-2">
                <Badge
                  style={{
                    backgroundColor: statusCor,
                    color: '#fff',
                    fontSize: 13,
                    padding: '4px 10px',
                  }}
                >
                  {statusLabel}
                </Badge>
                <span className="ml-3 text-muted" style={{ fontSize: 12 }}>
                  Cód. Ativo: <strong>{detalhe.codigo_ativo}</strong>
                  {' | '}Quadra: <strong>{detalhe.mapa1}</strong>
                  {' | '}Lote: <strong>{detalhe.mapa2}</strong>
                </span>
              </Col>
            </Row>

            {detalhe.status === 'R' && detalhe.nome_usuario_reserva && (
              <Row className="mb-2" style={{ fontSize: 13 }}>
                <Col xs={6}><strong>Reservado por:</strong> {detalhe.nome_usuario_reserva}</Col>
                <Col xs={6}><strong>Data Reserva:</strong> {formatarData(detalhe.data_reserva)}</Col>
              </Row>
            )}

            <Row className="mb-2" style={{ fontSize: 13 }}>
              <Col xs={4}><strong>Dormitórios:</strong> {detalhe.dormitorios != null ? detalhe.dormitorios : '-'}</Col>
              <Col xs={4}><strong>Suítes:</strong> {detalhe.suites != null ? detalhe.suites : '-'}</Col>
              <Col xs={4}><strong>Banheiros:</strong> {detalhe.banheiros != null ? detalhe.banheiros : '-'}</Col>
              <Col xs={4}><strong>Área Construída:</strong> {detalhe.area_construida != null ? `${detalhe.area_construida} m²` : '-'}</Col>
              <Col xs={4}><strong>Área Total:</strong> {detalhe.area_total != null ? `${detalhe.area_total} m²` : '-'}</Col>
              <Col xs={4}><strong>Garagem:</strong> {detalhe.garagem || '-'}</Col>
              <Col xs={4}><strong>Matrícula:</strong> {detalhe.matricula || '-'}</Col>
              <Col xs={4}><strong>Cartório:</strong> {detalhe.cartorio || '-'}</Col>
              <Col xs={4}><strong>Cad. Pref.:</strong> {detalhe.cad_pref || '-'}</Col>
              <Col xs={4}><strong>Preço Padrão:</strong> {formatarMoeda(detalhe.preco_padrao)}</Col>
              <Col xs={4}><strong>Preço Base:</strong> {formatarMoeda(detalhe.preco_base)}</Col>
            </Row>

            {detalhe.pre_venda && (
              <>
                <hr className="my-2" />
                <div style={{ fontSize: 13 }}><strong>Pré-Venda</strong></div>
                <Row style={{ fontSize: 12 }}>
                  <Col xs={3}><strong>Nº:</strong> {detalhe.pre_venda.numero}</Col>
                  <Col xs={3}><strong>Data:</strong> {formatarData(detalhe.pre_venda.data_cad)}</Col>
                  <Col xs={3}><strong>Status:</strong> {detalhe.pre_venda.status}</Col>
                  <Col xs={12}><strong>Cliente:</strong> {detalhe.pre_venda.cliente}</Col>
                  <Col xs={12}><strong>Corretor:</strong> {detalhe.pre_venda.corretor || '-'}</Col>
                </Row>
              </>
            )}

            {detalhe.venda && (
              <>
                <hr className="my-2" />
                <div style={{ fontSize: 13 }}><strong>Venda</strong></div>
                <Row style={{ fontSize: 12 }}>
                  <Col xs={4}><strong>Data:</strong> {formatarData(detalhe.venda.data_negocio)}</Col>
                  <Col xs={8}><strong>Cliente:</strong> {detalhe.venda.cliente}</Col>
                </Row>
              </>
            )}

            {detalhe.tickets && detalhe.tickets.length > 0 && (
              <>
                <hr className="my-2" />
                <div style={{ fontSize: 13 }}><strong>Tickets Vinculados</strong></div>
                <Table size="sm" bordered hover style={{ fontSize: 12 }}>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Status</th>
                      <th>Validade</th>
                      <th>Cliente</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detalhe.tickets.map((t) => (
                      <tr key={t.codigo_ticket}>
                        <td>{t.codigo_ticket}</td>
                        <td>{t.status}</td>
                        <td>{formatarData(t.validade)}</td>
                        <td>{t.cliente}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}

            {detalhe.ultimo_log && (
              <>
                <hr className="my-2" />
                <div style={{ fontSize: 12 }}>
                  <strong>Última Alteração:</strong>{' '}
                  {formatarDataHora(detalhe.ultimo_log.data)}{' '}
                  — {detalhe.ultimo_log.nome_usuario}{' '}
                  — {detalhe.ultimo_log.texto}
                </div>
              </>
            )}

            {podeAlterar && (
              <>
                <hr className="my-2" />
                <div style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 8 }}>Alterar Status</div>
                <Row>
                  <Col xs={12} md={4} className="mb-2">
                    <label style={{ fontSize: 12 }}>Novo Status</label>
                    <Select
                      styles={selectStyles}
                      options={opcoesFiltradas}
                      value={novoStatus}
                      onChange={(op) => {
                        setNovoStatus(op);
                        if (op && op.value !== 'B') {
                          setCpf('');
                          setExclusivo(false);
                        }
                      }}
                      placeholder="Selecione..."
                    />
                  </Col>
                  {novoStatus && novoStatus.value === 'B' && (
                    <>
                      <Col xs={12} md={4} className="mb-2">
                        <label style={{ fontSize: 12 }}>CPF (opcional)</label>
                        <Form.Control
                          size="sm"
                          value={cpf}
                          onChange={(e) => setCpf(e.target.value)}
                          placeholder="CPF para bloqueio"
                        />
                      </Col>
                      {temPerm251 && (
                        <Col xs={12} md={4} className="mb-2 d-flex align-items-end">
                          <Form.Check
                            type="checkbox"
                            label="Bloqueio Exclusivo"
                            checked={exclusivo}
                            onChange={(e) => setExclusivo(e.target.checked)}
                            style={{ fontSize: 12 }}
                          />
                        </Col>
                      )}
                    </>
                  )}
                  <Col xs={12} className="mb-2">
                    <label style={{ fontSize: 12 }}>Observação</label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      size="sm"
                      value={observacao}
                      onChange={(e) => setObservacao(e.target.value)}
                      placeholder="Observação (opcional)"
                    />
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {podeAlterar && (
          <Button
            variant="primary"
            size="sm"
            onClick={handleConfirmar}
            disabled={loading || !novoStatus}
          >
            {loading ? 'Salvando...' : 'Confirmar Alteração'}
          </Button>
        )}
        <Button variant="secondary" size="sm" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalhe;
